import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  avatarWaiting: {
    width: '52px',
    height: '52px',
    border: '2px solid #787B80',
  },
}));
